import { AlertTriangle } from "lucide-react";

export function FactsToConfirm({ facts }: { facts: string[] }) {
	if (facts.length === 0) {
		return null;
	}

	return (
		<div data-slot="facts-to-confirm" className="flex flex-col gap-1.5">
			<span className="text-xs font-medium uppercase tracking-wide text-warning/80">
				fatos sem confirmação
			</span>

			<div className="flex flex-wrap items-center gap-x-2.5 gap-y-1.5">
				{facts.map((fact) => (
					<span
						key={fact}
						data-slot="fact-chip"
						className="inline-flex flex-wrap items-center gap-1.5"
					>
						<span className="inline-flex items-center gap-1 rounded-md border border-warning/30 bg-warning/10 px-2 py-0.5 text-xs font-medium text-warning">
							<AlertTriangle className="size-3" />
							{fact}
						</span>
					</span>
				))}
			</div>
		</div>
	);
}
